export default __webpack_public_path__ + "static/media/heartbeat.bdbe5f81.svg";